import { render, staticRenderFns } from "./AverageSales.vue?vue&type=template&id=9978d978&scoped=true"
import script from "./AverageSales.vue?vue&type=script&lang=js"
export * from "./AverageSales.vue?vue&type=script&lang=js"
import style0 from "./AverageSales.vue?vue&type=style&index=0&id=9978d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9978d978",
  null
  
)

export default component.exports